
// src/actions/route.js

import { hashHistory } from 'react-router'
import routes from '../web/routes'
import map from 'lodash/map'
import each from 'lodash/each'

export function _findRoute(route, name, params, path) {
  if (route.props.name == name) {
    var restParams = {}
    if (params)
      each(params, (value, key)=> {
        if (path.match(`:${key}`))
          path = path.replace(`:${key}`, value)
        else
          restParams[key] = value
      })
    const param = map(restParams, (value, key)=> {
      return `${key}=${encodeURIComponent(value)}`
    }).join('&')

    return path.replace(/\/+/g, '/') + (param ? '?' + param : '')
  }

  var children = route.props.children
  if (children && !(children instanceof Array)) {
    children = [children]
  }
  for (var i = 0; children && i < children.length; i ++) {
    var _path = children[i].props.path || path
    if (_path.slice(0, 1) != '/') {
      _path = `${path}/${children[i].props.path}`
    }
    var result = _findRoute(children[i], name, params, _path)
    if (result)
      return result
  }
}

export function findRoute(name, params) {
  return _findRoute(routes, name, params, '/')
}

export function pushRoute(name, params = {}) {
  var path = findRoute(name, params)
  if (path)
    hashHistory.push(findRoute(name, params))
}

export function replaceRoute(name, params = {}) {
  var path = findRoute(name, params)
  if (path)
    hashHistory.replace(findRoute(name, params))
}

export function directRoute(path) {
  hashHistory.replace(path)
}



// WEBPACK FOOTER //
// ./src/actions/route.js